import type { CheckoutConfig } from '#types/config/pages/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    itemSelected: 'bg-grey-90'
  },
  contactFieldsOrder: ['email', 'phone'],
  hideLoyaltyDivider: false,
  isTaxRefundable: true,
  isFeeRefundable: true,
  legalCheckboxStep: 'shipping',
  loyaltyType: [
    'LOYALTY_POINTS',
  ],
  showCheckoutFooter: true,
  showTotalBeforeRewards: false
} satisfies RecursivePartial<CheckoutConfig>
